export const Space = 'Space';
export const KeyA = 'KeyA';
export const KeyS = 'KeyS';
export const KeyW = 'KeyW';
export const KeyQ = 'KeyQ';
export const KeyE = 'KeyE';
export const KeyR = 'KeyR';
export const KeyT = 'KeyT';
export const KeyY = 'KeyY';
export const KeyP = 'KeyP';
export const KeyD = 'KeyD';
